import { c as _slicedToArray, a as _toConsumableArray, f as _asyncToGenerator, h as _objectDestructuringEmpty } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useRef, useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { Modal, QuantaFormik, useQuantaFormikContext, QuantaForm, QuantaInput, Text, Chip, Button, Label, Grid, GridItem, QuantaCheckbox } from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faEnvelope, faSms } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { M as MOBILE_NUMBER_STARTING_WITH } from './queries-d745c605.js';
import { u as useFetchQuery } from './useFetchQuery-56ba5b94.js';
import 'react-helmet';
import 'react-router-dom';
import './queries-3df8abcc.js';
import { E as Error } from './error-ee5266a9.js';
import { L as Loading } from './loading-c16d3bd3.js';
import './queries-a3e6305b.js';

function ModalSendEmail(_ref) {
  var setShowEmail = _ref.setShowEmail,
      showEmail = _ref.showEmail,
      initialEmail = _ref.initialEmail,
      getPayLoad = _ref.getPayLoad,
      SEND_EMAIL_QUERY = _ref.SEND_EMAIL_QUERY;
  var sendEmailRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalDisplay = _useState2[0],
      setModalDisplay = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      displayMessage = _useState4[0],
      setDisplayMessage = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      sentSuccess = _useState6[0],
      setSentSuccess = _useState6[1];

  var _useMutation = useMutation(SEND_EMAIL_QUERY, {
    onCompleted: function onCompleted(data) {
      var _data$;

      setSentSuccess(true);
      setDisplayMessage((_data$ = data["".concat(Object.keys(data)[0])]) === null || _data$ === void 0 ? void 0 : _data$.message);
    },
    onError: function onError(_) {
      setSentSuccess(false);
      setDisplayMessage('Email send failed...Please try again after some time.');
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      doSendQuoteEmailAlert = _useMutation2[0],
      loading = _useMutation2[1].loading;

  useEffect(function () {
    var timer = setTimeout(function () {
      setModalDisplay(showEmail);
    }, 150);
    return function cleanup() {
      clearTimeout(timer);
      setDisplayMessage(null);
      setSentSuccess(true);
    };
  }, [showEmail, setModalDisplay]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, _ref2) {
      var _validate;

      var setFieldValue, variables;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setFieldValue = _ref2.setFieldValue;
              setDisplayMessage(null);
              variables = null;

              if (!(values !== null && values !== void 0 && values.ccEmail && !((_validate = validate(values)) !== null && _validate !== void 0 && _validate.ccEmail))) {
                _context.next = 11;
                break;
              }

              setFieldValue("ccEmailIDs", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.ccEmailIDs), [values === null || values === void 0 ? void 0 : values.ccEmail]));
              setFieldValue("ccEmail", '');
              _context.next = 8;
              return getPayLoad(values.email, [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.ccEmailIDs), [values === null || values === void 0 ? void 0 : values.ccEmail]));

            case 8:
              variables = _context.sent;
              _context.next = 14;
              break;

            case 11:
              _context.next = 13;
              return getPayLoad(values.email, values === null || values === void 0 ? void 0 : values.ccEmailIDs);

            case 13:
              variables = _context.sent;

            case 14:
              if (SEND_EMAIL_QUERY) {
                doSendQuoteEmailAlert({
                  variables: variables
                });
              }

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var initialValues = {
    email: initialEmail ? initialEmail : '',
    ccEmailIDs: [],
    ccEmail: ''
  };

  var validate = function validate(values) {
    var _values$ccEmail, _values$ccEmail$trim, _values$email, _values$email$trim, _values$ccEmailIDs;

    var errors = {};
    var email_check = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

    if (!values.email) {
      errors.email = '* Required';
    } else if (!email_check.test(values.email)) {
      errors.email = '* Please enter valid email address.';
    }

    if (values !== null && values !== void 0 && values.ccEmail && !email_check.test(values === null || values === void 0 ? void 0 : values.ccEmail)) {
      errors.ccEmail = '* Please enter valid email address.';
    } else if (values !== null && values !== void 0 && values.ccEmail && ((values === null || values === void 0 ? void 0 : (_values$ccEmail = values.ccEmail) === null || _values$ccEmail === void 0 ? void 0 : (_values$ccEmail$trim = _values$ccEmail.trim()) === null || _values$ccEmail$trim === void 0 ? void 0 : _values$ccEmail$trim.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$email = values.email) === null || _values$email === void 0 ? void 0 : (_values$email$trim = _values$email.trim()) === null || _values$email$trim === void 0 ? void 0 : _values$email$trim.toLowerCase()) || values !== null && values !== void 0 && (_values$ccEmailIDs = values.ccEmailIDs) !== null && _values$ccEmailIDs !== void 0 && _values$ccEmailIDs.find(function (ccEmailId) {
      var _ccEmailId$trim, _values$ccEmail2, _values$ccEmail2$trim;

      return (ccEmailId === null || ccEmailId === void 0 ? void 0 : (_ccEmailId$trim = ccEmailId.trim()) === null || _ccEmailId$trim === void 0 ? void 0 : _ccEmailId$trim.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$ccEmail2 = values.ccEmail) === null || _values$ccEmail2 === void 0 ? void 0 : (_values$ccEmail2$trim = _values$ccEmail2.trim()) === null || _values$ccEmail2$trim === void 0 ? void 0 : _values$ccEmail2$trim.toLowerCase());
    }))) {
      errors.ccEmail = '* This email ID is already added';
    }

    return errors;
  };

  var onModalClose = function onModalClose() {
    setModalDisplay(false);
    setShowEmail(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  var SendEmailForm = function SendEmailForm(_ref4) {
    var _values$ccEmailIDs3, _values$ccEmailIDs4;

    _ref4.initialValues;
        var validate = _ref4.validate;
        _ref4.onSubmit;

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values,
        setFieldValue = _useQuantaFormikConte.setFieldValue;

    return /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(QuantaInput, {
      name: "email",
      size: "full",
      type: "email",
      placeholder: "Please enter your email",
      disabled: loading,
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, ' ', "Email ID ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*"))
    }), /*#__PURE__*/React.createElement(QuantaInput, {
      name: "ccEmail",
      type: 'email',
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, " CC/Reference Email IDs "),
      size: 'full',
      placeholder: 'Enter CC/Reference Email IDs',
      disabled: loading,
      onKeyDown: function onKeyDown(evt) {
        var _ref5, _evt$key, _evt$key$toString, _evt$key$toString$tri;

        if ((_ref5 = ['tab', 'enter', ',', ';']) !== null && _ref5 !== void 0 && _ref5.includes(evt === null || evt === void 0 ? void 0 : (_evt$key = evt.key) === null || _evt$key === void 0 ? void 0 : (_evt$key$toString = _evt$key.toString()) === null || _evt$key$toString === void 0 ? void 0 : (_evt$key$toString$tri = _evt$key$toString.trim()) === null || _evt$key$toString$tri === void 0 ? void 0 : _evt$key$toString$tri.toLowerCase())) {
          var _validate2;

          evt.preventDefault();

          if (values !== null && values !== void 0 && values.ccEmail && !((_validate2 = validate(values)) !== null && _validate2 !== void 0 && _validate2.ccEmail)) {
            var _values$ccEmail3;

            setFieldValue("ccEmailIDs", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.ccEmailIDs), [values === null || values === void 0 ? void 0 : (_values$ccEmail3 = values.ccEmail) === null || _values$ccEmail3 === void 0 ? void 0 : _values$ccEmail3.trim()]));
            setFieldValue("ccEmail", '');
          }
        }
      },
      onPaste: function onPaste(evt) {
        evt.preventDefault();
        var paste = evt.clipboardData.getData('text');
        var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

        if (emails) {
          var toBeAdded = emails.filter(function (email) {
            var _values$ccEmailIDs2;

            return !(values !== null && values !== void 0 && (_values$ccEmailIDs2 = values.ccEmailIDs) !== null && _values$ccEmailIDs2 !== void 0 && _values$ccEmailIDs2.includes(email)) && email !== (values === null || values === void 0 ? void 0 : values.email);
          });
          setFieldValue("ccEmailIDs", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.ccEmailIDs), _toConsumableArray(toBeAdded)));
        }
      }
    }), (values === null || values === void 0 ? void 0 : (_values$ccEmailIDs3 = values.ccEmailIDs) === null || _values$ccEmailIDs3 === void 0 ? void 0 : _values$ccEmailIDs3.length) > 0 && /*#__PURE__*/React.createElement(Text, {
      className: "flex gap-3 flex-wrap"
    }, values === null || values === void 0 ? void 0 : (_values$ccEmailIDs4 = values.ccEmailIDs) === null || _values$ccEmailIDs4 === void 0 ? void 0 : _values$ccEmailIDs4.map(function (ccEmailId, idx) {
      return /*#__PURE__*/React.createElement(Chip, {
        key: idx,
        onRemove: function onRemove(_) {
          var _values$ccEmailIDs5, _values$ccEmailIDs6;

          return setFieldValue("ccEmailIDs", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$ccEmailIDs5 = values.ccEmailIDs) === null || _values$ccEmailIDs5 === void 0 ? void 0 : _values$ccEmailIDs5.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$ccEmailIDs6 = values.ccEmailIDs) === null || _values$ccEmailIDs6 === void 0 ? void 0 : _values$ccEmailIDs6.slice(idx + 1))));
        },
        isChipDisabled: loading
      }, ccEmailId);
    })), displayMessage && !loading ? /*#__PURE__*/React.createElement(Text, {
      severity: sentSuccess ? 'success' : 'error'
    }, displayMessage) : /*#__PURE__*/React.createElement("div", null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
      size: "full",
      type: "submit",
      className: "mt-4",
      disabled: loading,
      iconPre: loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true,
        className: "ml-2"
      }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faEnvelope,
        className: "ml-2"
      })
    }, loading ? "Sending..." : "Send Email"));
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: modalDisplay,
    size: "medium",
    title: "Verify/Enter your email",
    severity: "action",
    onClose: function onClose() {
      var _sendEmailRef$current;

      onModalClose();
      sendEmailRef === null || sendEmailRef === void 0 ? void 0 : (_sendEmailRef$current = sendEmailRef.current) === null || _sendEmailRef$current === void 0 ? void 0 : _sendEmailRef$current.resetForm();
    },
    modalCloseDisabled: loading
  }, /*#__PURE__*/React.createElement(QuantaFormik, {
    innerRef: sendEmailRef,
    enableReinitialize: true,
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(SendEmailForm, {
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  })));
}

function ModalSendSms(_ref) {
  var setShowSms = _ref.setShowSms,
      showSms = _ref.showSms,
      initialMobile = _ref.initialMobile,
      getPayLoad = _ref.getPayLoad,
      SEND_SMS_QUERY = _ref.SEND_SMS_QUERY;
  var sendSmsRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalDisplay = _useState2[0],
      setModalDisplay = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      displayMessage = _useState4[0],
      setDisplayMessage = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      sentSuccess = _useState6[0],
      setSentSuccess = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      mobileNumberStartingWith = _useState8[0],
      setMobileNumberStartingWith = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loadingMobileNumberStartingWith = _useState10[0],
      setLoadingMobileNumberStartingWith = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      errorMobileNumberStartingWith = _useState12[0],
      setErrorMobileNumberStartingWith = _useState12[1];

  var fetchQuery = useFetchQuery();

  var _useMutation = useMutation(SEND_SMS_QUERY, {
    onCompleted: function onCompleted(data) {
      var _data$;

      setSentSuccess(true);
      setDisplayMessage((_data$ = data["".concat(Object.keys(data)[0])]) === null || _data$ === void 0 ? void 0 : _data$.message);
    },
    onError: function onError(_) {
      setSentSuccess(false);
      setDisplayMessage('Message send failed...Please try again after some time.');
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      doSendQuoteSMSAlert = _useMutation2[0],
      loading = _useMutation2[1].loading;

  useEffect(function () {
    var isMounted = true;

    if (showSms && isMounted && !mobileNumberStartingWith) {
      var _fetchQuery, _fetchQuery$then;

      setLoadingMobileNumberStartingWith(true);
      setErrorMobileNumberStartingWith(null);
      (_fetchQuery = fetchQuery({
        query: MOBILE_NUMBER_STARTING_WITH,
        fetchPolicy: 'cache-first'
      })) === null || _fetchQuery === void 0 ? void 0 : (_fetchQuery$then = _fetchQuery.then(function (response) {
        if (isMounted) {
          var _response$data;

          setLoadingMobileNumberStartingWith(false);
          setMobileNumberStartingWith(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.mobileNumberStartingWith);
        }
      })) === null || _fetchQuery$then === void 0 ? void 0 : _fetchQuery$then.catch(function (error) {
        if (isMounted) {
          setLoadingMobileNumberStartingWith(false);
          setErrorMobileNumberStartingWith(error === null || error === void 0 ? void 0 : error.message);
        }
      });
    }

    return function () {
      isMounted = false;
    };
  }, [showSms, mobileNumberStartingWith]);
  useEffect(function () {
    var timer = setTimeout(function () {
      setModalDisplay(showSms);
    }, 150);
    return function () {
      clearTimeout(timer);
      setDisplayMessage(null);
      setSentSuccess(true);
    };
  }, [showSms, setModalDisplay]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, _ref2) {
      var _values$mode, _values$mode2;

      var setFieldValue, _validate, variables, _values$mode3, _values$mode4, _values$mode5, _values$mode6, _values$mode7, _values$mode8, _values$mode9, _values$mode10, _values$mode11, _values$mode12, _values$mode13, _values$mode14, _values$mode15, _values$mode16, _values$mode17, _values$mode18, _values$mode19, _values$mode20;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setFieldValue = _ref2.setFieldValue;

              if (!(!(values !== null && values !== void 0 && (_values$mode = values.mode) !== null && _values$mode !== void 0 && _values$mode.sms) && !(values !== null && values !== void 0 && (_values$mode2 = values.mode) !== null && _values$mode2 !== void 0 && _values$mode2.whatsapp))) {
                _context.next = 6;
                break;
              }

              setSentSuccess(false);
              setDisplayMessage('Atleast one mode must be selected');
              _context.next = 20;
              break;

            case 6:
              setDisplayMessage(null);
              variables = null;

              if (!(values !== null && values !== void 0 && values.alternateMobile && !((_validate = validate(values)) !== null && _validate !== void 0 && _validate.alternateMobile))) {
                _context.next = 16;
                break;
              }

              setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), [values === null || values === void 0 ? void 0 : values.alternateMobile]));
              setFieldValue("alternateMobile", '');
              _context.next = 13;
              return getPayLoad(values !== null && values !== void 0 && (_values$mode3 = values.mode) !== null && _values$mode3 !== void 0 && _values$mode3.sms ? values.mobile : '', values !== null && values !== void 0 && (_values$mode4 = values.mode) !== null && _values$mode4 !== void 0 && _values$mode4.sms ? [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), [values === null || values === void 0 ? void 0 : values.alternateMobile]) : [], values !== null && values !== void 0 && values.isWhatsAppSameAsMobile && values !== null && values !== void 0 && (_values$mode5 = values.mode) !== null && _values$mode5 !== void 0 && _values$mode5.sms && values !== null && values !== void 0 && (_values$mode6 = values.mode) !== null && _values$mode6 !== void 0 && _values$mode6.whatsapp ? values === null || values === void 0 ? void 0 : values.mobile : values !== null && values !== void 0 && (_values$mode7 = values.mode) !== null && _values$mode7 !== void 0 && _values$mode7.whatsapp ? values === null || values === void 0 ? void 0 : values.whatsappNo : '', values !== null && values !== void 0 && (_values$mode8 = values.mode) !== null && _values$mode8 !== void 0 && _values$mode8.sms && values !== null && values !== void 0 && (_values$mode9 = values.mode) !== null && _values$mode9 !== void 0 && _values$mode9.whatsapp ? ['sms', 'whatsapp'] : !(values !== null && values !== void 0 && (_values$mode10 = values.mode) !== null && _values$mode10 !== void 0 && _values$mode10.sms) && values !== null && values !== void 0 && (_values$mode11 = values.mode) !== null && _values$mode11 !== void 0 && _values$mode11.whatsapp ? ['whatsapp'] : ['sms']);

            case 13:
              variables = _context.sent;
              _context.next = 19;
              break;

            case 16:
              _context.next = 18;
              return getPayLoad(values !== null && values !== void 0 && (_values$mode12 = values.mode) !== null && _values$mode12 !== void 0 && _values$mode12.sms ? values.mobile : '', values !== null && values !== void 0 && (_values$mode13 = values.mode) !== null && _values$mode13 !== void 0 && _values$mode13.sms ? values === null || values === void 0 ? void 0 : values.alternateMobileNos : [], values !== null && values !== void 0 && values.isWhatsAppSameAsMobile && values !== null && values !== void 0 && (_values$mode14 = values.mode) !== null && _values$mode14 !== void 0 && _values$mode14.sms && values !== null && values !== void 0 && (_values$mode15 = values.mode) !== null && _values$mode15 !== void 0 && _values$mode15.whatsapp ? values === null || values === void 0 ? void 0 : values.mobile : values !== null && values !== void 0 && (_values$mode16 = values.mode) !== null && _values$mode16 !== void 0 && _values$mode16.whatsapp ? values === null || values === void 0 ? void 0 : values.whatsappNo : '', values !== null && values !== void 0 && (_values$mode17 = values.mode) !== null && _values$mode17 !== void 0 && _values$mode17.sms && values !== null && values !== void 0 && (_values$mode18 = values.mode) !== null && _values$mode18 !== void 0 && _values$mode18.whatsapp ? ['sms', 'whatsapp'] : !(values !== null && values !== void 0 && (_values$mode19 = values.mode) !== null && _values$mode19 !== void 0 && _values$mode19.sms) && values !== null && values !== void 0 && (_values$mode20 = values.mode) !== null && _values$mode20 !== void 0 && _values$mode20.whatsapp ? ['whatsapp'] : ['sms']);

            case 18:
              variables = _context.sent;

            case 19:
              doSendQuoteSMSAlert({
                variables: variables
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var initialValues = {
    mobile: initialMobile ? initialMobile : '',
    alternateMobile: '',
    alternateMobileNos: [],
    whatsappNo: initialMobile ? initialMobile : '',
    isWhatsAppSameAsMobile: true,
    mode: {
      sms: true,
      whatsapp: false
    }
  };

  var validate = function validate(values) {
    var _values$alternateMobi, _values$alternateMobi2, _values$alternateMobi3, _values$alternateMobi4, _values$mobile, _values$mobile$trim, _values$alternateMobi5, _values$mode21;

    var errors = {};

    if (!values.mobile) {
      errors.mobile = '* Required';
    } else if (parseInt(values === null || values === void 0 ? void 0 : values.mobile[0]) < parseInt(mobileNumberStartingWith === null || mobileNumberStartingWith === void 0 ? void 0 : mobileNumberStartingWith.value)) {
      errors.mobile = "* Mobile number must start with digit ".concat(mobileNumberStartingWith === null || mobileNumberStartingWith === void 0 ? void 0 : mobileNumberStartingWith.value, " to 9");
    } else if (values.mobile.toString().length !== 10 || !values.mobile.toString().match(/^[0-9]+$/)) {
      errors.mobile = '* Mobile number must be of 10 digits';
    }

    if (values !== null && values !== void 0 && values.alternateMobile && parseInt(values === null || values === void 0 ? void 0 : values.alternateMobile[0]) < parseInt(mobileNumberStartingWith === null || mobileNumberStartingWith === void 0 ? void 0 : mobileNumberStartingWith.value)) {
      errors.alternateMobile = "* Mobile number must start with digit ".concat(mobileNumberStartingWith === null || mobileNumberStartingWith === void 0 ? void 0 : mobileNumberStartingWith.value, " to 9");
    } else if (values !== null && values !== void 0 && values.alternateMobile && (values.alternateMobile.toString().length !== 10 || !(values !== null && values !== void 0 && (_values$alternateMobi = values.alternateMobile) !== null && _values$alternateMobi !== void 0 && (_values$alternateMobi2 = _values$alternateMobi.toString()) !== null && _values$alternateMobi2 !== void 0 && _values$alternateMobi2.match(/^[0-9]+$/)))) {
      errors.alternateMobile = '* Mobile number must be of 10 digits';
    } else if (values !== null && values !== void 0 && values.alternateMobile && ((values === null || values === void 0 ? void 0 : (_values$alternateMobi3 = values.alternateMobile) === null || _values$alternateMobi3 === void 0 ? void 0 : (_values$alternateMobi4 = _values$alternateMobi3.trim()) === null || _values$alternateMobi4 === void 0 ? void 0 : _values$alternateMobi4.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$mobile = values.mobile) === null || _values$mobile === void 0 ? void 0 : (_values$mobile$trim = _values$mobile.trim()) === null || _values$mobile$trim === void 0 ? void 0 : _values$mobile$trim.toLowerCase()) || values !== null && values !== void 0 && (_values$alternateMobi5 = values.alternateMobileNos) !== null && _values$alternateMobi5 !== void 0 && _values$alternateMobi5.find(function (alternateMob) {
      var _alternateMob$trim, _values$alternateMobi6, _values$alternateMobi7;

      return (alternateMob === null || alternateMob === void 0 ? void 0 : (_alternateMob$trim = alternateMob.trim()) === null || _alternateMob$trim === void 0 ? void 0 : _alternateMob$trim.toLowerCase()) === (values === null || values === void 0 ? void 0 : (_values$alternateMobi6 = values.alternateMobile) === null || _values$alternateMobi6 === void 0 ? void 0 : (_values$alternateMobi7 = _values$alternateMobi6.trim()) === null || _values$alternateMobi7 === void 0 ? void 0 : _values$alternateMobi7.toLowerCase());
    }))) {
      errors.alternateMobile = '* This mobile no is already added';
    }

    if (values !== null && values !== void 0 && (_values$mode21 = values.mode) !== null && _values$mode21 !== void 0 && _values$mode21.whatsapp) {
      var _values$mode22, _values$mode23, _values$mobile2, _values$whatsappNo;

      if (!(values !== null && values !== void 0 && values.whatsappNo)) {
        errors.whatsappNo = '* Required';
      } else if (!(values !== null && values !== void 0 && values.isWhatsAppSameAsMobile) && values !== null && values !== void 0 && (_values$mode22 = values.mode) !== null && _values$mode22 !== void 0 && _values$mode22.sms && values !== null && values !== void 0 && (_values$mode23 = values.mode) !== null && _values$mode23 !== void 0 && _values$mode23.whatsapp && (values === null || values === void 0 ? void 0 : (_values$mobile2 = values.mobile) === null || _values$mobile2 === void 0 ? void 0 : _values$mobile2.toString()) === (values === null || values === void 0 ? void 0 : (_values$whatsappNo = values.whatsappNo) === null || _values$whatsappNo === void 0 ? void 0 : _values$whatsappNo.toString())) {
        errors.whatsappNo = '* WhatsApp No cannot be same as mobile no';
      } else if (parseInt(values === null || values === void 0 ? void 0 : values.whatsappNo[0]) < parseInt(mobileNumberStartingWith === null || mobileNumberStartingWith === void 0 ? void 0 : mobileNumberStartingWith.value)) {
        errors.whatsappNo = "* WhatsApp No must start with digit ".concat(mobileNumberStartingWith === null || mobileNumberStartingWith === void 0 ? void 0 : mobileNumberStartingWith.value, " to 9");
      } else if (values.whatsappNo.toString().length !== 10 || !values.whatsappNo.toString().match(/^[0-9]+$/)) {
        errors.whatsappNo = '* WhatsApp No must be of 10 digits';
      }
    }

    return errors;
  };

  var onModalClose = function onModalClose() {
    setModalDisplay(false);
    setShowSms(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  var SendSMSForm = function SendSMSForm(_ref4) {
    var _values$mode24, _values$mode25, _values$mode26, _values$mode27, _values$alternateMobi10, _values$alternateMobi11, _values$mode28, _values$mode29, _values$alternateMobi16, _values$alternateMobi17, _values$mode30, _values$mode31, _values$mode32, _values$mode33, _values$mode34, _values$mode35, _values$mode36, _values$mode37, _values$mode38, _values$mode39, _values$mode40, _values$mode41;

    _objectDestructuringEmpty(_ref4);

    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values,
        setFieldValue = _useQuantaFormikConte.setFieldValue;

    return /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(Label, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, "Select the mode ", /*#__PURE__*/React.createElement(Text, {
        severity: 'error'
      }, "*"))
    }, /*#__PURE__*/React.createElement(Grid, {
      repeat: 3,
      gap: 0
    }, /*#__PURE__*/React.createElement(GridItem, {
      colSpan: 1
    }, /*#__PURE__*/React.createElement(QuantaCheckbox, {
      name: 'mode.sms',
      label: "SMS",
      disabled: loading
    })))), values !== null && values !== void 0 && (_values$mode24 = values.mode) !== null && _values$mode24 !== void 0 && _values$mode24.whatsapp && !(values !== null && values !== void 0 && (_values$mode25 = values.mode) !== null && _values$mode25 !== void 0 && _values$mode25.sms) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaInput, {
      name: "whatsappNo",
      disabled: loading,
      size: "full",
      type: "number",
      step: "1",
      min: 1000000000,
      max: 9999999999,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, ' ', "WhatsApp No ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      placeholder: "Please enter your WhatsApp Number"
    })) : !(values !== null && values !== void 0 && (_values$mode26 = values.mode) !== null && _values$mode26 !== void 0 && _values$mode26.whatsapp) && values !== null && values !== void 0 && (_values$mode27 = values.mode) !== null && _values$mode27 !== void 0 && _values$mode27.sms ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaInput, {
      name: "mobile",
      size: "full",
      type: "number",
      step: "1",
      min: 1000000000,
      max: 9999999999,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, ' ', "Mobile No ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      placeholder: "Please enter your mobile Number",
      disabled: loading
    }), /*#__PURE__*/React.createElement(QuantaInput, {
      name: "alternateMobile",
      type: 'text',
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, "Alternative Mobile Nos"),
      size: 'full',
      placeholder: 'Enter alternative numbers for SMS',
      disabled: loading,
      onKeyDown: function onKeyDown(evt) {
        var _ref5, _evt$key, _evt$key$toString, _evt$key$toString$tri;

        if ((_ref5 = ['tab', 'enter', ',', ';']) !== null && _ref5 !== void 0 && _ref5.includes(evt === null || evt === void 0 ? void 0 : (_evt$key = evt.key) === null || _evt$key === void 0 ? void 0 : (_evt$key$toString = _evt$key.toString()) === null || _evt$key$toString === void 0 ? void 0 : (_evt$key$toString$tri = _evt$key$toString.trim()) === null || _evt$key$toString$tri === void 0 ? void 0 : _evt$key$toString$tri.toLowerCase())) {
          var _validate2;

          evt.preventDefault();

          if (values !== null && values !== void 0 && values.alternateMobile && !((_validate2 = validate(values)) !== null && _validate2 !== void 0 && _validate2.alternateMobile)) {
            var _values$alternateMobi8;

            setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), [values === null || values === void 0 ? void 0 : (_values$alternateMobi8 = values.alternateMobile) === null || _values$alternateMobi8 === void 0 ? void 0 : _values$alternateMobi8.trim()]));
            setFieldValue("alternateMobile", '');
          }
        }
      },
      onPaste: function onPaste(evt) {
        var _evt$clipboardData$ge, _evt$clipboardData$ge2;

        evt.preventDefault();
        var paste = (_evt$clipboardData$ge = evt.clipboardData.getData('text')) === null || _evt$clipboardData$ge === void 0 ? void 0 : (_evt$clipboardData$ge2 = _evt$clipboardData$ge.toString()) === null || _evt$clipboardData$ge2 === void 0 ? void 0 : _evt$clipboardData$ge2.trim();
        var phones = paste.match(/[0-9]{10}/g);

        if (phones) {
          var toBeAdded = phones.filter(function (phone) {
            var _values$alternateMobi9;

            return !(values !== null && values !== void 0 && (_values$alternateMobi9 = values.alternateMobileNos) !== null && _values$alternateMobi9 !== void 0 && _values$alternateMobi9.includes(phone)) && phone !== (values === null || values === void 0 ? void 0 : values.mobile);
          });
          setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), _toConsumableArray(toBeAdded)));
        }
      }
    }), (values === null || values === void 0 ? void 0 : (_values$alternateMobi10 = values.alternateMobileNos) === null || _values$alternateMobi10 === void 0 ? void 0 : _values$alternateMobi10.length) > 0 && /*#__PURE__*/React.createElement(Text, {
      className: "flex gap-3 flex-wrap"
    }, values === null || values === void 0 ? void 0 : (_values$alternateMobi11 = values.alternateMobileNos) === null || _values$alternateMobi11 === void 0 ? void 0 : _values$alternateMobi11.map(function (alternateMobile, idx) {
      return /*#__PURE__*/React.createElement(Chip, {
        key: idx,
        onRemove: function onRemove(_) {
          var _values$alternateMobi12, _values$alternateMobi13;

          return setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$alternateMobi12 = values.alternateMobileNos) === null || _values$alternateMobi12 === void 0 ? void 0 : _values$alternateMobi12.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$alternateMobi13 = values.alternateMobileNos) === null || _values$alternateMobi13 === void 0 ? void 0 : _values$alternateMobi13.slice(idx + 1))));
        },
        isChipDisabled: loading
      }, alternateMobile);
    }))) : values !== null && values !== void 0 && (_values$mode28 = values.mode) !== null && _values$mode28 !== void 0 && _values$mode28.whatsapp && values !== null && values !== void 0 && (_values$mode29 = values.mode) !== null && _values$mode29 !== void 0 && _values$mode29.sms ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaInput, {
      name: "mobile",
      size: "full",
      type: "number",
      step: "1",
      min: 1000000000,
      max: 9999999999,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, ' ', "Mobile No ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      placeholder: "Please enter your mobile Number",
      disabled: loading,
      onDataChange: function onDataChange(val, _) {
        if (values !== null && values !== void 0 && values.isWhatsAppSameAsMobile) {
          setFieldValue('whatsappNo', val);
        }
      }
    }), /*#__PURE__*/React.createElement(QuantaCheckbox, {
      name: 'isWhatsAppSameAsMobile',
      label: "WhatsApp no. same as mobile no.",
      disabled: loading,
      onDataChange: function onDataChange(val) {
        if (!val) {
          setFieldValue('whatsappNo', '');
        } else {
          setFieldValue('whatsappNo', values === null || values === void 0 ? void 0 : values.mobile);
        }
      }
    }), !(values !== null && values !== void 0 && values.isWhatsAppSameAsMobile) && /*#__PURE__*/React.createElement(QuantaInput, {
      name: "whatsappNo",
      disabled: loading,
      size: "full",
      type: "number",
      step: "1",
      min: 1000000000,
      max: 9999999999,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, ' ', "WhatsApp No ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      placeholder: "Please enter your WhatsApp Number"
    }), /*#__PURE__*/React.createElement(QuantaInput, {
      name: "alternateMobile",
      type: 'text',
      label: /*#__PURE__*/React.createElement(Text, {
        type: 'label'
      }, "Alternative Mobile Nos"),
      size: 'full',
      placeholder: 'Enter alternative numbers for SMS',
      disabled: loading,
      onKeyDown: function onKeyDown(evt) {
        var _ref6, _evt$key2, _evt$key2$toString, _evt$key2$toString$tr;

        if ((_ref6 = ['tab', 'enter', ',', ';']) !== null && _ref6 !== void 0 && _ref6.includes(evt === null || evt === void 0 ? void 0 : (_evt$key2 = evt.key) === null || _evt$key2 === void 0 ? void 0 : (_evt$key2$toString = _evt$key2.toString()) === null || _evt$key2$toString === void 0 ? void 0 : (_evt$key2$toString$tr = _evt$key2$toString.trim()) === null || _evt$key2$toString$tr === void 0 ? void 0 : _evt$key2$toString$tr.toLowerCase())) {
          var _validate3;

          evt.preventDefault();

          if (values !== null && values !== void 0 && values.alternateMobile && !((_validate3 = validate(values)) !== null && _validate3 !== void 0 && _validate3.alternateMobile)) {
            var _values$alternateMobi14;

            setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), [values === null || values === void 0 ? void 0 : (_values$alternateMobi14 = values.alternateMobile) === null || _values$alternateMobi14 === void 0 ? void 0 : _values$alternateMobi14.trim()]));
            setFieldValue("alternateMobile", '');
          }
        }
      },
      onPaste: function onPaste(evt) {
        var _evt$clipboardData$ge3, _evt$clipboardData$ge4;

        evt.preventDefault();
        var paste = (_evt$clipboardData$ge3 = evt.clipboardData.getData('text')) === null || _evt$clipboardData$ge3 === void 0 ? void 0 : (_evt$clipboardData$ge4 = _evt$clipboardData$ge3.toString()) === null || _evt$clipboardData$ge4 === void 0 ? void 0 : _evt$clipboardData$ge4.trim();
        var phones = paste.match(/[0-9]{10}/g);

        if (phones) {
          var toBeAdded = phones.filter(function (phone) {
            var _values$alternateMobi15;

            return !(values !== null && values !== void 0 && (_values$alternateMobi15 = values.alternateMobileNos) !== null && _values$alternateMobi15 !== void 0 && _values$alternateMobi15.includes(phone)) && phone !== (values === null || values === void 0 ? void 0 : values.mobile);
          });
          setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : values.alternateMobileNos), _toConsumableArray(toBeAdded)));
        }
      }
    }), (values === null || values === void 0 ? void 0 : (_values$alternateMobi16 = values.alternateMobileNos) === null || _values$alternateMobi16 === void 0 ? void 0 : _values$alternateMobi16.length) > 0 && /*#__PURE__*/React.createElement(Text, {
      className: "flex gap-3 flex-wrap"
    }, values === null || values === void 0 ? void 0 : (_values$alternateMobi17 = values.alternateMobileNos) === null || _values$alternateMobi17 === void 0 ? void 0 : _values$alternateMobi17.map(function (alternateMobile, idx) {
      return /*#__PURE__*/React.createElement(Chip, {
        key: idx,
        onRemove: function onRemove(_) {
          var _values$alternateMobi18, _values$alternateMobi19;

          return setFieldValue("alternateMobileNos", [].concat(_toConsumableArray(values === null || values === void 0 ? void 0 : (_values$alternateMobi18 = values.alternateMobileNos) === null || _values$alternateMobi18 === void 0 ? void 0 : _values$alternateMobi18.slice(0, idx)), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$alternateMobi19 = values.alternateMobileNos) === null || _values$alternateMobi19 === void 0 ? void 0 : _values$alternateMobi19.slice(idx + 1))));
        },
        isChipDisabled: loading
      }, alternateMobile);
    }))) : null, displayMessage && !loading ? /*#__PURE__*/React.createElement(Text, {
      severity: sentSuccess ? 'success' : 'error'
    }, displayMessage) : /*#__PURE__*/React.createElement("div", null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
      size: "full",
      type: "submit",
      className: "mt-4",
      disabled: loading || !(values !== null && values !== void 0 && (_values$mode30 = values.mode) !== null && _values$mode30 !== void 0 && _values$mode30.sms) && !(values !== null && values !== void 0 && (_values$mode31 = values.mode) !== null && _values$mode31 !== void 0 && _values$mode31.whatsapp),
      iconPre: loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true,
        className: "ml-2"
      }) : values !== null && values !== void 0 && (_values$mode32 = values.mode) !== null && _values$mode32 !== void 0 && _values$mode32.sms && values !== null && values !== void 0 && (_values$mode33 = values.mode) !== null && _values$mode33 !== void 0 && _values$mode33.whatsapp || values !== null && values !== void 0 && (_values$mode34 = values.mode) !== null && _values$mode34 !== void 0 && _values$mode34.sms && !(values !== null && values !== void 0 && (_values$mode35 = values.mode) !== null && _values$mode35 !== void 0 && _values$mode35.whatsapp) || !(values !== null && values !== void 0 && (_values$mode36 = values.mode) !== null && _values$mode36 !== void 0 && _values$mode36.sms) && !(values !== null && values !== void 0 && (_values$mode37 = values.mode) !== null && _values$mode37 !== void 0 && _values$mode37.whatsapp) ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSms,
        className: "ml-2"
      }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faWhatsapp,
        className: "ml-2"
      })
    }, loading ? "Sending..." : values !== null && values !== void 0 && (_values$mode38 = values.mode) !== null && _values$mode38 !== void 0 && _values$mode38.sms && values !== null && values !== void 0 && (_values$mode39 = values.mode) !== null && _values$mode39 !== void 0 && _values$mode39.whatsapp ? "Send SMS & WhatsApp" : values !== null && values !== void 0 && (_values$mode40 = values.mode) !== null && _values$mode40 !== void 0 && _values$mode40.sms ? "Send SMS" : values !== null && values !== void 0 && (_values$mode41 = values.mode) !== null && _values$mode41 !== void 0 && _values$mode41.whatsapp ? "Send WhatsApp" : "Send SMS"));
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: modalDisplay,
    size: "medium",
    title: "Verify/Enter your Mobile No.",
    severity: "action",
    onClose: function onClose() {
      var _sendSmsRef$current;

      onModalClose();
      sendSmsRef === null || sendSmsRef === void 0 ? void 0 : (_sendSmsRef$current = sendSmsRef.current) === null || _sendSmsRef$current === void 0 ? void 0 : _sendSmsRef$current.resetForm();
    },
    modalCloseDisabled: loading
  }, loadingMobileNumberStartingWith && /*#__PURE__*/React.createElement(Loading, null), errorMobileNumberStartingWith && /*#__PURE__*/React.createElement(Error, {
    error: errorMobileNumberStartingWith
  }), mobileNumberStartingWith && !loadingMobileNumberStartingWith && !errorMobileNumberStartingWith && /*#__PURE__*/React.createElement(QuantaFormik, {
    innerRef: sendSmsRef,
    enableReinitialize: true,
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(SendSMSForm, {
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  })));
}

export { ModalSendSms as M, ModalSendEmail as a };
